import type { TelemetryPort } from '@core/domain/ports/driven/TelemetryPort.ts';

/** No-op I/O when telemetry is disabled. */
export class NoopTelemetryAdapter implements TelemetryPort {
  /** References arguments so implementations are not empty and stay tree-shake friendly. */
  private static touch(...args: unknown[]): number {
    return args.length;
  }
  /** Log info. */


  logInfo(message: string, context?: Record<string, unknown>): void {
    NoopTelemetryAdapter.touch(message, context);
  }
  /** Log error. */


  logError(error: Error | string, context?: Record<string, unknown>): void {
    NoopTelemetryAdapter.touch(error, context);
  }
  /** Track event. */


  trackEvent(eventName: string, payload?: Record<string, unknown>): void {
    NoopTelemetryAdapter.touch(eventName, payload);
  }
  /** Sets user context. */


  setUserContext(user: { id: string; role?: string; [key: string]: unknown } | null): void {
    NoopTelemetryAdapter.touch(user);
  }
  /** Log http request. */


  logHttpRequest(meta: { correlationId: string; method: string; url: string }): void {
    NoopTelemetryAdapter.touch(meta);
  }
  /** Log http response. */


  logHttpResponse(meta: { correlationId: string; status: number; durationMs: number; url: string }): void {
    NoopTelemetryAdapter.touch(meta);
  }
  /** Start trace. */


  startTrace(
    spanName: string,
    options?: { correlationId?: string }
  ): { end: () => void; fail: (err: Error) => void } {
    NoopTelemetryAdapter.touch(spanName, options);
    return {
      end: () => {
        NoopTelemetryAdapter.touch();
      },
      fail: (err: Error) => {
        NoopTelemetryAdapter.touch(err);
      },
    };
  }
  /** Record metric counter. */


  recordMetricCounter(
    name: string,
    value?: number,
    attributes?: Record<string, string | number | boolean>
  ): void {
    NoopTelemetryAdapter.touch(name, value, attributes);
  }
  /** Record metric histogram. */


  recordMetricHistogram(
    name: string,
    value: number,
    attributes?: Record<string, string | number | boolean>
  ): void {
    NoopTelemetryAdapter.touch(name, value, attributes);
  }
}
